import { StarEmpty } from '@/shared/images/icons/StarEmpty';
import * as S from './TableOfContents.styles';

type TItem = [string, string[]];

type TTableOfContentsProps = {
    items: TItem[];
    isDesktop?: boolean;
};

export const TableOfContents = ({ items, isDesktop }: TTableOfContentsProps) => {
    return (
        <S.TableContainer isDesktop={isDesktop}>
            <S.TableTitle>Table of Contents</S.TableTitle>
            {items.map(([title, items]) => {
                return (
                    <S.TableBlock key={title}>
                        <S.MainItem>
                            <div
                                onClick={() => {
                                    const content = document
                                        ?.getElementById('blog-content')
                                        ?.querySelectorAll('h2');

                                    if (content) {
                                        Array.from(content)
                                            ?.find((data) => data.innerText.includes(title))
                                            ?.scrollIntoView({
                                                behavior: 'smooth',
                                                block: 'center',
                                            });
                                    }
                                }}
                            >
                                <StarEmpty />

                                {title}
                            </div>
                            {!!items.length && (
                                <S.ItemsBlock>
                                    {items.map((item) => (
                                        <S.Item key={item}>{item}</S.Item>
                                    ))}
                                </S.ItemsBlock>
                            )}
                        </S.MainItem>
                    </S.TableBlock>
                );
            })}
        </S.TableContainer>
    );
};
